import { Component, OnInit, inject } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { finalize, switchMap, tap, map } from 'rxjs/operators';

import { HtmlEntities } from '@shared';

import { TimeWindowSuggestionView } from './models/time-window-suggestion-view.model';
import { PatientsTimeWindowSuggestionsService } from './services/patients-time-window-suggestions.service';

@Component({
    selector: 'app-patients-time-window-suggestions',
    templateUrl: './patients-time-window-suggestions.component.html',
    styleUrls: ['./patients-time-window-suggestions.component.scss'],
    standalone: false
})
export class PatientsTimeWindowSuggestionsComponent implements OnInit {
    private readonly patientsTimeWindowSuggestionsService = inject(PatientsTimeWindowSuggestionsService);

    public loading: boolean;
    public handlingSuggestions: boolean;
    public selectAll: boolean;
    public disableButtons: boolean;
    public suggestions: TimeWindowSuggestionView[];
    public confirm$: Subject<void>;

    constructor() {
        this.confirm$ = new Subject();
        this.disableButtons = true;
    }

    ngOnInit(): void {
        this.loading = true;
        this.loadTimeWindowSuggestions().subscribe();
    }

    public dismissModal(): void {
        this.confirm$.next();
    }

    public handleSuggestions(suggestions: TimeWindowSuggestionView[], accept: boolean = false): void {
        this.disableButtons = true;
        this.handlingSuggestions = true;

        const ids = suggestions.filter(suggestion => suggestion.checked).map(suggestion => suggestion.improvementId);

        this.patientsTimeWindowSuggestionsService
            .handleSuggestions(ids, accept)
            .pipe(switchMap(() => this.loadTimeWindowSuggestions()))
            .subscribe();
    }

    public toggleSelection(suggestion: TimeWindowSuggestionView, event: Event): void {
        event.preventDefault();
        suggestion.checked = !suggestion.checked;
        this.disableButtons = !this.suggestions.some(i => i.checked);

        if (!suggestion.checked && this.selectAll) {
            this.selectAll = false;
        }
    }

    public toggleSelectionAll(suggestions: TimeWindowSuggestionView[]): void {
        this.disableButtons = !this.selectAll;
        suggestions.forEach(suggestion => (suggestion.checked = this.selectAll));
    }

    private loadTimeWindowSuggestions(): Observable<void> {
        return this.patientsTimeWindowSuggestionsService.getTimeWindowSuggestions().pipe(
            tap(suggestions => {
                if(!suggestions) {
                    return;
                }
                if (suggestions.length === 0) {
                    this.confirm$.next();
                } else {
                    this.suggestions = suggestions.map(suggestion => {
                        suggestion.taskDescription = HtmlEntities.decode(suggestion.taskDescription);
                        return suggestion;
                    });
                }
            }),
            map(() => null),
            finalize(() => {
                this.loading = false;
                this.handlingSuggestions = false;
            })
        );
    }
}
